function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

function mergeDeep(target, ...sources) {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key of Object.keys(source)) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return mergeDeep(target, ...sources)
}

const isProduction = process.env.NODE_ENV === 'production'
const isStaging = process.env.NODE_ENV === 'staging'

const config = {
  client: {
    ssl: false,
    domain: 'localhost:8082',
    getUrl() {
      return `${this.ssl ? 'https://' : 'http://'}${this.domain}`
    }
  },
  api: {
    ssl: false,
    domain: 'localhost:8081',
    getUrl() {
      return `${this.ssl ? 'https://' : 'http://'}${this.domain}`
    }
  },
  ws: {
    domain: 'localhost:8080',
    getUrl() {
      return `${this.ssl ? 'wss://' : 'ws://'}${this.domain}`
    }
  },
  docportal: {
    ssl: false,
    domain: 'localhost:1234',
    getUrl() {
      return `${this.ssl ? 'https://' : 'http://'}${this.domain}`
    }
  },
  loggedInCookie: 'review-loggedIn-dev'
}

const productionConfig = {
  client: {
    ssl: true,
    domain: 'review.cmdr-ops.com'
  },
  api: {
    ssl: true,
    domain: 'api.review.cmdr-ops.com'
  },
  ws: {
    ssl: true,
    domain: 'ws.review.cmdr-ops.com'
  },
  docportal: {
    ssl: true,
    domain: 'cmdr-ops.com'
  },
  loggedInCookie: 'review-loggedIn'
}

const stagingConfig = {
  client: {
    ssl: true,
    domain: 'stage.review.cmdr-ops.com'
  },
  api: {
    ssl: true,
    domain: 'stage.api.review.cmdr-ops.com'
  },
  ws: {
    ssl: true,
    domain: 'stage.ws.review.cmdr-ops.com'
  },
  docportal: {
    ssl: true,
    domain: 'stage.cmdr-ops.com'
  },
  loggedInCookie: 'review-loggedIn-stage'
}

let combinedConfig = config
if (isProduction) combinedConfig = mergeDeep(config, productionConfig)
if (isStaging) combinedConfig = mergeDeep(config, stagingConfig)

export default combinedConfig
